import { Outlet, useLocation, useParams } from 'react-router';
import PathwayFlow from '@/components/pathways/PathwayFlow';
import PathwayRegistry from '@/components/pathways/PathwayRegistry';
import AnchorContainer from '@/components/nodes/AnchorContainer';
import CustomPropertyContainer from '@/components/nodes/CustomPropertyContainer';
import { ReactFlowProvider } from '@xyflow/react';
import WalkthroughButton from '@/components/core/WalkthroughButton';
import StatusAlerts from '@/components/pathways/StatusAlerts';

const PathwayRoute = () => {
  const { nodeId } = useParams();
  const containerClasses = nodeId ? 'visible' : 'invisible !min-w-0';
  const location = useLocation();
  const isControlPanel = location.pathname.includes('/control-panel');

  return (
    <ReactFlowProvider>
      <div className="flex-grow h-full flex relative">
        {!isControlPanel && (
          <div className="flex flex-col h-full flex-grow bg-white select-none">
            <PathwayRegistry />
            <div className="absolute z-[100] flex float-right w-full">
              <StatusAlerts />
            </div>
            <WalkthroughButton type="modules" />
            <PathwayFlow />
            <AnchorContainer />
            <CustomPropertyContainer />
          </div>
        )}
        <div
          className={`${nodeId ? 'min-w-[34rem]' : 'w-0'} overflow-hidden bg-white transition-all duration-200 border-l border-gray-200 z-[400] ${containerClasses}`}
        >
          <Outlet />
        </div>
      </div>
    </ReactFlowProvider>
  );
};

export default PathwayRoute;
